import Vue from 'vue'
import { apiUserLogin, apiUserRegister } from "@/apis/api.js"; 
import router from '@/router'
import { 
    sendLoginLog,
} from "@/apis/global/log.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    auth_request: 'user/auth_request',
    auth_error: 'user/auth_error',
    auth_success: 'user/auth_success',
    logout: 'user/logout',
}

// count state 必須是 Object
const state = {
    status: '',
    token: localStorage.getItem('token') || '',
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
}

// actions 也是以 Object 形式建構。
const actions = {
    landlordLogin({commit, dispatch}, user){
        return new Promise((resolve, reject) => {
            commit(types.auth_request)
            console.log(user)
            apiUserLogin(user)
            .then(res => {
                if(res.data.status === 'SUCCESS'){
                    // console.log(res.data.result.access_token)
                    let token = res.data.result.access_token;
                    let refreshToken = res.data.result.refresh_token;
                    localStorage.setItem('token', token)
                    localStorage.setItem('refreshToken', refreshToken)
                    commit(types.auth_success, token)
                    // 取得會員資料
                    dispatch('sendLoginLog', 'WEB_LANDLORD')
                    .then(()=>{
                        resolve(res)
                    })
                }else{
                    reject(res)
                }
                
            })
            .catch(err => {
                commit(types.auth_error)
                localStorage.removeItem('token')
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    landlordRegister({commit}, user){
        return new Promise((resolve, reject) => {
            commit(types.auth_request)
            apiUserRegister(user)
            .then(res => {
                console.log(res)
                resolve(res)
            })
            .catch(err => {
                commit(types.auth_error, err)
                localStorage.removeItem('token')
                reject(err)
            })
        })
    },logout({commit}){
        return new Promise((resolve, reject) => {
            commit(types.logout)
            localStorage.removeItem('token')
            localStorage.removeItem('userState')
            router.push({name: 'landlordLogin'})
            resolve()
        })
    },
    sendLoginLog ( {commit, dispatch}, loginFrom ) {
        return new Promise((resolve, reject) => {
            const data = {
                loginFrom: loginFrom,
                model: Vue.prototype.getBrowser(),
                version: Vue.prototype.getSys(),
            }
            sendLoginLog(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                }
                resolve()
            })
            .catch(err => {
            })
        })
    },
}

// mutations
const mutations = {
    [types.auth_request](state){
        state.status = 'loading'
    },
    [types.auth_error](state){
        state.status = 'error'
    },
    [types.auth_success](state, token){
        state.status = 'success'
        state.token = token
    },
    [types.logout](state){
        state.status = ''
        state.token = ''
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/user.js